import React from 'react';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';
import { DoctorBank } from 'types/doctor';

interface DoctorBanksListProps {
  banks: DoctorBank[];
  handleDeleteBank(bank: DoctorBank, index: number): void;
  handleEditBank(bank: DoctorBank, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'bank', label: 'Banco' },
  { id: 'agency', label: 'Agência' },
  { id: 'account', label: 'Conta' },
  { id: 'pix', label: 'Chave Pix' },
];

const DoctorBanksList: React.FC<DoctorBanksListProps> = ({ banks, handleDeleteBank, handleEditBank }) => (
  <RecordList
    columns={columns}
    rows={banks.map((bank, index) => ({
      key: bank.id || index,
      values: {
        bank: bank.bank_name,
        agency: bank.bank_agency || '-',
        account: bank.bank_account || '-',
        pix: bank.pix_key ? `${bank.pix_key_type ? `${bank.pix_key_type} · ` : ''}${bank.pix_key}` : '-',
      },
    }))}
    onEdit={index => handleEditBank(banks[index], index)}
    onDelete={index => handleDeleteBank(banks[index], index)}
  />
);

export default DoctorBanksList;
